/* eslint-disable */

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const lockBackground = (menuOpen) => {
  if (menuOpen) {
      const offsetY = window.pageYOffset;
      document.body.style.top = `${-offsetY}px`;
      document.body.classList.add('js-lock-position');
  } else {
      const offsetY = Math.abs(parseInt(document.body.style.top || 0, 10));
      document.body.classList.remove('js-lock-position');
      document.body.style.removeProperty('top');
      window.scrollTo(0, offsetY || 0);
  }
};

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    // event.preventDefault();
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
  

  /* When you leave the dropdown, close it */
  // if(summary.classList.contains('header__menu-item')) {
  //   let myElement = document.getElementById(summary.getAttribute('aria-controls'));
  //   myElement.addEventListener('mouseleave',event => {
  //     summary.setAttribute('aria-expanded',false);
  //     summary.parentNode.removeAttribute('open');
  //   });
  // }
  /* When it hovers, it clicks */
  if(summary.classList.contains('header__menu-item')) {
    summary.parentNode.addEventListener('mouseenter', event => {
      summary.setAttribute('aria-expanded',true);
      summary.parentNode.setAttribute('open',true);
    });
    summary.parentNode.addEventListener('mouseleave', event => {
      summary.setAttribute('aria-expanded',false);
      summary.parentNode.removeAttribute('open');
    });
  } 

  
  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    // Get current updated variant_id 
    let currUpdatedItemID = this.getAttribute("data-variant-id");
    window.currUpdatedItemID = currUpdatedItemID;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      const cartPageItems = this.closest(".cart-items.cart-page-items");
      if(cartPageItems){
        cartPageItems.setAttribute("data-qty-updated", "true");
      }

      if(Number(this.input.value) === 0){
        if(this.closest(".cart-item").querySelector("cart-remove-button")){
          this.closest(".cart-item").querySelector("cart-remove-button").click();
        }
      }else{
        this.input.dispatchEvent(this.changeEvent);
      }
    };
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.money_format="${{amount}}",Shopify.formatMoney=function(a,o){"string"==typeof a&&(a=a.replace(".",""));var e="",t=/\{\{\s*(\w+)\s*\}\}/,o=o||this.money_format;function r(a,o){return void 0===a?o:a}function n(a,o,e,t){if(o=r(o,2),e=r(e,","),t=r(t,"."),isNaN(a)||null==a)return 0;a=(a=(a/100).toFixed(o)).split(".");return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g,"$1"+e)+(a[1]?t+a[1]:"")}switch(o.match(t)[1]){case"amount":e=n(a,2);break;case"amount_no_decimals":e=n(a,0);break;case"amount_with_comma_separator":e=n(a,2,".",",");break;case"amount_no_decimals_with_comma_separator":e=n(a,0,".",",")}return o.replace(t,e)};

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button[class*="close"]').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    this.scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add(`menu-drawer__${this.tagName}--open`);
    document.body.style.paddingRight = `${this.scrollbarWidth}px`;
    
    const root = document.getElementsByTagName( 'html' )[0];
    root.classList.add(`menu-drawer__${this.tagName}--open`);
  }

  closeMenuDrawer(event, elementToFocus = false) {

    if (event === undefined) {
      return;
    }

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.remove(`menu-drawer__${this.tagName}--open`);
    document.body.style.paddingRight = '';
    
    const root = document.getElementsByTagName( 'html' )[0];
    root.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    root.classList.remove(`menu-drawer__${this.tagName}--open`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');    
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header') || document.getElementById('shopify-section-ab-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
    this.autoplay(poster);
  }
  
  autoplay(poster) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const intersecting = entry.isIntersecting
        if(entry.isIntersecting) {
          this.loadContent(false);
          playPauseVideo();
//           this.querySelector('video').play();
        }
      })
    });

    observer.observe(poster)
  }
    

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.json = JSON.parse(this.closest('.card').getAttribute('data-json'));
    this.querySelectorAll('input').forEach((input) => {
      input.addEventListener('change', this.addItem.bind(this));
    });
    this.button = this.querySelector('.quick-add-btn');
    if(this.button) {
      this.button.addEventListener('click', this.addItem.bind(this));  
    }
    
  }  
  async addItem(event) {
    event.preventDefault();

    const target = event.target
    const itemId = target.getAttribute('data-id')
    const closestSpinner = this.closest('.card-wrapper').querySelector('.loading-overlay__spinner')

    const quickAddElement = target.closest("quick-add");
    const isPreOrderInput = quickAddElement ? quickAddElement.querySelector(".preorder__field") : null;
    const isBadgeInput = quickAddElement ? quickAddElement.querySelector(".badgeProperties__field") : null;

    if(closestSpinner) {
      closestSpinner.classList.add('active');
    }


    const quickAddObj = {
      items: [{
          id: itemId,
          quantity: 1,
          ...(isPreOrderInput && {
              properties: {
                [isPreOrderInput.name]: isPreOrderInput.value
              }
          }),
          ...(isBadgeInput && {
            properties: {
              [isBadgeInput.name]: isBadgeInput.value
            }
          })
      }]
    };
    addToCart(quickAddObj);
    
  }
}
customElements.define('quick-add', QuickAdd);

class QuickAddTrigger extends HTMLElement {
  connectedCallback() {
    this._button = this.querySelector('button');
    if (this._button) {
      this._button.addEventListener('click', this._handleClick.bind(this));
    }
  }

  _handleClick(event) {
    event.preventDefault();
    const cardWrapper = this.closest('.card-wrapper');
    if (!cardWrapper) return;
    const quickAddBtn = cardWrapper.querySelector('.quick-add-btn');
    if (quickAddBtn) quickAddBtn.click();
  }
}
customElements.define('quick-add-trigger', QuickAddTrigger);

class UpsellItem extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('.quick-add-btn');
    this.button.addEventListener('click', this.addItem.bind(this));

    const plusIcon = this.querySelector('.icon-plus');
    if (plusIcon) {
      plusIcon.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        addToCart({ items: [{ id: this.button.getAttribute('data-id'), quantity: 1 }] });
      });
    }
  }  
  addItem(event) {
    event.preventDefault();
    const quickAddObj = {
      items: [
        {
          id: event.currentTarget.getAttribute('data-id'),
          quantity: 1
        }
      ]
    }
    addToCart(quickAddObj);
  }
}
customElements.define('upsell-item', UpsellItem);


class CardSwatches extends HTMLElement {
  constructor() {
    super();
    this.json = JSON.parse(this.closest('.card').getAttribute('data-json')) || false;
//     console.log(this.json);
    this.data = false;
  }
  findColors() {
//     if(!this.json) return;
    fetch(`/search?q=${this.json[0].productStyle}&type=product&view=api`)
    .then(response => response.json())
    .then(data => {
      if(data.length <= 1) return;
      this.data = data;
      this.buildSwatches();
    })
    .catch(error => console.log(error))
    .finally(end => {
    });
  }
  buildSwatches() {
    this.data.forEach(item => {
      if(item.title.indexOf('Extended') > -1) return;
      const colorIndex = item.options.indexOf('Color');
      const colorValue = item.variants[0].options[colorIndex];
      const swatch = document.createElement('button');
      swatch.classList.add('card-swatch__button');
      swatch.setAttribute('data-color',colorValue);
      if(colorValue == this.json[0].color) {
        swatch.classList.add('active');
      }
      swatch.setAttribute('data-product',`/products/${item.handle}?view=card`);
      this.appendChild(swatch);
      swatch.addEventListener('click', this.updateContent.bind(this));
//       this.addEventListener('keyup', this.onKeyUp.bind(this));
    });
    this.classList.add('swatches-loaded');
  }
  updateContent(event) {
    const elementsToUpdate = [
      '.card__media',
      '.quick-add__wrapper',
      '.card__main-content',
      '.card__badge'
    ];
    const myCard = event.target.closest('.product-card');
    fetch(event.target.getAttribute('data-product'))
    .then(response => response.text())
    .then(data => {
      var parser = new DOMParser();
      var doc = parser.parseFromString(data,'text/html');
      elementsToUpdate.forEach(el => {
        const currentEl = myCard.querySelector(el);
        const newEl = doc.querySelector(el);
        if(currentEl && newEl) {
          currentEl.innerHTML = newEl.innerHTML;
        }
        lazyImages();
      });
      myCard.querySelectorAll('.card-swatch__button').forEach(button => {
        button.classList.remove('active');
      });
      event.target.classList.add('active');
      const newJson = doc.querySelector('.product-card').getAttribute('data-json');
      myCard.setAttribute('data-json',newJson);
      myCard.querySelector('quick-add').json = JSON.parse(newJson);
      
    })
    .catch(error => console.log(error));
  }
}

customElements.define('card-swatches', CardSwatches);


const playPauseVideo = () => {
  let videos = document.querySelectorAll("video");
  videos.forEach((video) => {
    // We can only control playback without insteraction if video is mute
    video.muted = true;
    // Play is a promise so we need to check we have it
    let playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.then((_) => {
        let observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.intersectionRatio <= 0 && !video.paused) {
                video.pause();
              } else if (video.paused) {
                video.play();
              }
            });
          }
        );
        observer.observe(video);
      });
    }
  });
}

// And you would kick this off where appropriate with:
playPauseVideo();


const lazyImages = () => {
  const targets = document.querySelectorAll(".media img");
  const lazyLoad = target => {
    if(target.classList.contains('fade')) return true;
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-src');
          img.setAttribute('src', src);
          img.classList.add('fade');
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.33
    });
    io.observe(target)
  };
  targets.forEach(lazyLoad);
};
lazyImages();


const totalColors = () => {
  if(!window.enableTotalColors) return;
  const targets = document.querySelectorAll(".total-colors");
  const getTotalColors = target => {
    if(target.classList.contains('colors-found')) return true;
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const cardStyle = entry.target.getAttribute('data-style');
          const cardColor = entry.target.getAttribute('data-color');
          let totalFound = 0;
          fetch(`/search?q=${cardStyle}&type=product&view=api`)
          .then(response => response.json())
          .then(data => {
            if(data.length <= 1) return;
            data.forEach(item => {
              const style = item.title.split(' - ')[0];
              if(style !== cardStyle) return;
              totalFound++;
            });
            
            if(totalFound > 1) {
              const allMatches = document.querySelectorAll(`.total-colors[data-style="${cardStyle}"]`);
              allMatches.forEach(match => {
                match.innerHTML = `+ ${totalFound} Colors`;
                match.classList.add('colors-found');
              });  
            }
          })
          .catch(error => console.log(error));
          observer.disconnect();
        }
      });
    }, {
      threshold: 0.5
    });
    io.observe(target);
  };
  targets.forEach(getTotalColors);
};


totalColors();


function recordRecentlyViewed(data) {
  
  const LIMIT = 50
  const recentlyViewed = JSON.parse(localStorage.getItem('_rv')) || []

  // Prevent duplicates
  if (recentlyViewed.find(item => item.id === data.id)) return

  // Add new item
  const updatedProducts = [...recentlyViewed, data]

  // Remove oldest if over limit
  if (updatedProducts.length > LIMIT) {
    updatedProducts.shift()
  }

  window.setRecentlyViewedNav()
  localStorage.setItem('_rv', JSON.stringify(updatedProducts))
}


const productCardHovers = () => {
  if(!window.enableCardSwatches) return;
  const productCards = document.querySelectorAll('.product-card');
  productCards.forEach(card => {
    const cardSwatches = card.querySelector('card-swatches');
    card.addEventListener('mouseenter', event => {
      if(cardSwatches.classList.contains('swatches-loaded')) return;
      cardSwatches.findColors();
    });
  });
};

let lastVariantIdForYotpo = null

function refreshYotpoVariant() {
  if (
    !window.ShopifyAnalytics ||
    !ShopifyAnalytics.meta ||
    !ShopifyAnalytics.meta.selectedVariantId
  ) return;

  const variantId = ShopifyAnalytics.meta.selectedVariantId;
  if (variantId === lastVariantIdForYotpo) return;

  lastVariantIdForYotpo = variantId;

  const widget = document.querySelector('.yotpo-widget-instance');
  if (!widget) return;

  widget.setAttribute('data-yotpo-variant-id', variantId);

  if (window.yotpoWidgetsContainer) {
    window.yotpoWidgetsContainer.refresh();
  }
}

productCardHovers();

const productSwatchReload = () => {
  // Guard against double-binding: this is called again after AJAX morphs replace
  // `.pdp-hero-wrap` wholesale (fresh nodes, safe to bind), but it's also called by
  // `pdp-colorway-drawer` after cloning swatch buttons into the drawer, where the
  // original (already-bound) swatches are still present alongside the new clones.
  const swatchCards = document.querySelectorAll('.swatch_image-a:not([data-swatch-bound])');
  swatchCards.forEach(card => {
    card.setAttribute('data-swatch-bound', 'true');
    card.addEventListener('click', (event) => {
      event.preventDefault();

      // Swatches clicked from inside the "explore more colorways" drawer stay open while the
      // variant swap fetch is in flight - a loading overlay (dimmed + spinner) is shown over
      // the drawer so it's clear the click registered and a response is pending, then the
      // drawer closes once the new content has loaded, letting its closing transition finish
      // before `.pdp-hero-wrap` (which contains the drawer itself) gets swapped out from under
      // it - otherwise the closing transition gets cut short and the drawer appears to glitch/jump.
      const drawer = card.closest('pdp-colorway-drawer');
      if (drawer && typeof drawer.showLoading === 'function') {
        drawer.showLoading();
        swapProductVariant(card).finally(() => {
          drawer.hideLoading();
          if (typeof drawer.close === 'function') drawer.close();
        });
        return;
      }

      swapProductVariant(card);
    });
  });
};

function swapProductVariant(card) {
  const productURL = card.getAttribute('href');
  const newProductId = card.getAttribute('data-product-id');
  const recentlyViewedJson = card.dataset.recentlyViewedProductJson ? JSON.parse(card.dataset.recentlyViewedProductJson) : null

  // record recetly viewed json

  if (recentlyViewedJson) {
    recordRecentlyViewed(recentlyViewedJson)
  }

  if(card.closest('.customSwatch') != null) {
    card.closest('.customSwatch').classList.add('btn--loading');
  }

  const elementsToUpdate = [
    '.pdp-hero-wrap',
    '.pdp-review-section',
    '.pdp-rc-section',
    'product-modal'
  ];

  return fetch(productURL)
  .then(response => response.text())
  .then(data => { 
    var parser = new DOMParser();
    var doc = parser.parseFromString(data,'text/html');
    
    elementsToUpdate.forEach(el => {
      const currentEl = document.querySelector(el);
      const newEl = doc.querySelector(el);
      if(currentEl && newEl) {
        currentEl.innerHTML = newEl.innerHTML;
      }
      if(document.querySelector('.pdp-hero-wrap .yotpo-widget-instance')) {
        yotpoWidgetsContainer.initWidgets()
      }
    });

    lazyImages();
    complimentary();
    productRecommendations();
    productSwatchReload();
    changeSwiperSlider();

    if (window.initMobileCarousel) window.initMobileCarousel();
    
    history.replaceState(null, "", `${productURL}`);
    
    // Dispatch event for product recommendations reload
    document.dispatchEvent(new CustomEvent('pdp:variant-swapped', {
      detail: { 
        productURL: productURL,
        productId: newProductId
      }
    }));
  }).finally(() => {
      if(document.querySelector('.swym-button.hammitt-custom')) {
        document.dispatchEvent(new CustomEvent("swym:collections-loaded"))
      }
      refreshYotpoVariant()
      window.initImgModelHeight()
  });
}

productSwatchReload();

const addToCart = (itemsObj) => {
  if(!itemsObj.hasOwnProperty('sections')) {
    itemsObj.sections = "cart-drawer,cart-icon-bubble,main-cart-items,header";
  }

  if(!itemsObj.hasOwnProperty('sections_url')) {
    itemsObj.sections_url = "/cart?sections=cart-drawer,cart-icon-bubble,main-cart-items,header";
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    body: JSON.stringify(itemsObj),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(json) {
    /* we have JSON */
    if(json.status == 422 && json.message == "Cart Error") {
      itemsObj.items.shift();
      addToCart(itemsObj);
    } else {
      cartUpdate(json);
    }
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.log(err)
  });
};

const klaviyoForms = () => {
  const subscribeForms = document.querySelectorAll(".klaviyo-subscribe");
  subscribeForms.forEach((form) => {
    const button = form.querySelector(".newsletter-form__button");
    button.addEventListener("click", function (e) {
      e.preventDefault();
	  klaviyoSubscribe(form);
    });
  });
  const bisForms = document.querySelectorAll(".klaviyo-bis");
  bisForms.forEach((form) => {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      theme.klaviyoSubscribe(form,function() {
        klaviyoBISsubmit(form);
      });
    });
  });
};

klaviyoForms();

const klaviyoSubscribe = (form, callback) => {
  
  const email = form.querySelector('input[name="email"]').value;
  const phone = form.querySelector('input[name="phone"]');
  const acceptsMarketing =  true;
  const listId = form.querySelector('input[name="g"]').value;
  const successMessage = form.getAttribute("data-success-message");
  const messages = form.querySelector(".messages");
  const subscribeUrl = "//manage.kmail-lists.com/ajax/subscriptions/subscribe";
  let phoneNumber = '';
  

  if (email === "") {
    messages.textContent = "Please enter a valid email address";
    messages.classList.remove("hidden");
    return false;
  } 
  
  if(phone && phone.value != '') {
    const countryCode = form.querySelector('.iti__selected-flag').getAttribute('title').split(': ')[1];
    phoneNumber = `${countryCode}${phone.value}`;
  }
  
  const bodyContent = {
    g: listId,
    email: email,
    sms_consent: true,
    $fields: '$phone_number,sms_consent',
    $phone_number: phoneNumber,
    $consent: ['sms']
  };

  fetch(subscribeUrl, {
    body: new URLSearchParams(bodyContent),
    method: "POST",
  })
  .then((response) => response.json())
  .then((response) => {

    if (response.success) {
      messages.textContent = successMessage;
    } else {
      messages.textContent = response.errors;
    }
    messages.classList.remove("hidden");
    if (callback && typeof callback === 'function') {
      callback();
    }
  })
  .catch((err) => {
    console.error(err);
  });
};

const klaviyoBISsubmit = (form) => {
  const url = "//a.klaviyo.com/onsite/components/back-in-stock/subscribe";
  const email = form.querySelector(".klaviyo-bis-email").value;
  const messages = form.querySelector(".messages");
  const hiddenInfo = form.querySelector('.klaviyo-variant-id');
  var variantId = false;
  var productId = false;
  if(hiddenInfo) {
    variantId = parseFloat(hiddenInfo.value);
    productId = hiddenInfo.getAttribute('product-id');
  } else {
    variantId = window.currentVariant.id || false;
    productId = window.currentVariant.productId || false;
  }
  
  const formBody = new URLSearchParams({
    a: window.klaviyoAccountId,
    email: email,
    variant: variantId,
    product: productId,
    platform: "shopify"
  });
  messages.classList.add("hidden");
  if (email === "") {
    messages.textContent = "Please enter a valid email";
    messages.classList.remove("hidden");
    return false;
  }

  fetch(url, {
    body: formBody,
    method: "POST",
  })
  .then((response) => response.json())
  .then((response) => {
    if (response.success) {
      messages.textContent = "You're in! We'll let you know when it's back.";
    } else {
    }
    messages.classList.remove("hidden");
  })
  .catch((err) => {
    console.error(err);
  });
};

function checkOrderProtection() {

  const initialJson = JSON.parse(document.querySelector('.drawer__items').getAttribute('data-json'))

  if(!initialJson) return

  initialJson.forEach((item) => {
    if(item.vendor  == "Order Protection") {
        
      let updatesObj = { 
        updates: {},
        sections: "cart-drawer,cart-icon-bubble,main-cart-items,header"
      }

      updatesObj.updates[item.variant_id] = 0
      
      const body = JSON.stringify(updatesObj)

      fetch(window.Shopify.routes.root + 'cart/update.js', { ...fetchConfig(), ...{ body }})
      .then(response => {
        return response.json()
      })
      .then((data)  => {

        // this update call is the same as whats called in cartUpdate() except it dosnt pop open the cart automatically or reload the page (also does not have
        // the logic that animates the GWP bar, as it will be hidden anyway). 
        const toUpdate = [
          {
            section: "cart-drawer",
            elements: [".cart-announcement-bar",".drawer__items",".drawer__final",".cart_shipping_notes", ".drawer__header h4"]
          },
          {
            section: "cart-icon-bubble",
            elements: [".cart-count-bubble"]
          }
        ]

        toUpdate.forEach((update) => {
          update.elements.forEach((element) => {

            const parser = new DOMParser()
            const doc = parser.parseFromString(data.sections[update.section], "text/html")
            const elOld = document.querySelector(element)
            const elNew = doc.querySelector(element)

            if(elOld && elNew) {
              elOld.outerHTML = elNew.outerHTML
            }

          })

        })

      })
      .catch((error) => {
        console.error('Error:', error);
      })


    }
  })

}

function reloadCartAndbubble() {
  
}

function updateCart(params) {  
  fetch(params.url, {
    method: 'POST',
    body: params.data,
    headers: {
      'Content-Type': 'application/json'
    }
  })
  .then(response => response.json())
  .then(function(cart) {
    cartUpdate(cart);
    const onCartPage = window.location.href.indexOf('/cart') > -1;
    if(onCartPage) {
      window.location.reload()
    }
  });
}

// initial on load check for Order Protection items to remove them from cart. They should only be in cart at checkout.
checkOrderProtection()

// document.addEventListener('change', function(evt) {
//   if(document.querySelector('.cart-drawer-btn') != null) {
//     document.querySelector('.cart-drawer-btn').disabled = true;  
//   }
  
//   if(document.querySelector('.cart__checkout-button') != null) {
//     document.querySelector('.cart__checkout-button').disabled = true;  
//   }
  
// });

const cartUpdate = (json = false) => {

  const cartUpdates = [
    // {
    //   section: "cart-drawer",
    //   elements: [".cart-announcement-bar",".drawer__items",".drawer__final", ".cart_shipping_notes", '.below-progress-bar-container', ".drawer__title"]
    // },
    {
      section: "cart-icon-bubble",
      elements: [".cart-count-bubble"]
    },
    {
      section: "header",
      elements: [".cart-announcement-bar",".drawer__items",".drawer__final", ".cart_shipping_notes", '.below-progress-bar-container', ".drawer__title", ".progress-bar-container"]
    }
  ];

  const mainCart = document.querySelector('.cart-main');

  if(mainCart) {
    cartUpdates.push({
      section: "main-cart-items",
      elements: ['.cart-items']
    });
    cartUpdates.push({
      section: "main-cart-footer",
      elements: ['#main-cart-footer']
    });
  }

  if(!json || json === undefined) {
    json = JSON.parse(document.querySelector('.drawer__items').getAttribute('data-json'));
  };

  // Captured below while swapping in the "header" section's markup - .drawer__items already carries
  // the full, current cart.items array (server-rendered) as its data-json attribute, so it can be
  // reused for reconciliation and the cart:updated event without any extra cart.js request.
  let latestCartItems = null;

  cartUpdates.forEach(update => {
    if(!json.sections[update.section]) return;
    update.elements.forEach(element => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(json.sections[update.section], "text/html");
      const elOld = document.querySelector(element);
      const elNew = doc.querySelector(element);

      if(element === '.drawer__items' && elNew) {
        const rawItemsJson = elNew.getAttribute('data-json');
        if(rawItemsJson) {
          try {
            latestCartItems = JSON.parse(rawItemsJson);
          } catch(e) {}
        }
      }

      if(elOld == null || elNew == null) return


      if(elOld && elNew) {
        elOld.outerHTML = elNew.outerHTML;
      }
    })

    // Trigger progress bar animation after DOM update
    const progressBar = document.querySelector('.progress-bar');
    if(progressBar) {
      // Force reflow to restart animation
      void progressBar.offsetWidth;
    }

    // Check and update Rivett Club component state after cart update
    const cartRivettClub = document.querySelector('cart-rivett-club');
    if (cartRivettClub) {
      const hasClosedBefore = localStorage.getItem('rivettClubClosed');
      if (hasClosedBefore === 'true') {
        cartRivettClub.classList.add('inactive');
      } else {
        cartRivettClub.classList.remove('inactive');
      }
    }

    cartUpsellSwiper();
  });

  // NOTE: this reconciliation + cart:updated dispatch must run exactly ONCE per cartUpdate() call,
  // not once per entry in cartUpdates above - it was previously nested inside the forEach loop,
  // which fired it 2-4 times concurrently and could cause an early `return` in one reconciliation
  // block (e.g. the legacy gifting-options-drawer sync) to skip the line-ribbon gift wrap sync below
  // on every one of those firings.
  const finishCartUpdate = (cart) => {
    // Both reconciliation checks below write into this single shared `updates` object and are
    // flushed with ONE updateCart() call at the end. They used to each `return` early on their own
    // fetch, which meant that whichever check ran first (the legacy gifting-options-drawer sync)
    // could permanently block the line-ribbon gift wrap sync from ever running whenever its own
    // count happened to be mismatched (e.g. after a "save for later" removal, unrelated to ribbons) -
    // orphaned ribbon gift-wrap lines were left in the cart forever as a result.
    const updates = {}

    // check if gifting drawer is active, update to the correct number of gift wraps in cart given the number of line items with gift notes
    const giftingOptionsActive = document.querySelector('hammitt-gifting-options-drawer') != null

    if(giftingOptionsActive) {

      const giftWrapProductVid = parseInt(document.querySelector('hammitt-gifting-options-drawer').getAttribute('data-gift-note-vid'))
      const { items } = cart

      let totalGiftWrapsCurrentlyInCart = 0
      let totalItemsWithGiftWrapPropertyInCart = 0

      items.forEach((item) => {
        if(item.id === giftWrapProductVid) {
          totalGiftWrapsCurrentlyInCart += item.quantity
        }
        if(item.properties && item.properties['_line_item_gift_note'] !== undefined) {
          totalItemsWithGiftWrapPropertyInCart += item.quantity
        }
      })

      if(totalItemsWithGiftWrapPropertyInCart != totalGiftWrapsCurrentlyInCart) {
        updates[giftWrapProductVid] = totalItemsWithGiftWrapPropertyInCart
      }

    }

    // Keep each gift-wrap-product cart line in sync with its associated source line item, matched
    // via a "_gift_wrap_for_line" property (set to the source line's key when its ribbon checkbox is
    // checked - see CartLevelLineRibbonUpsell). Handles quantity changes and removals of the source
    // line, reconciled here using the cart data already available above (no extra request needed).
    const lineRibbonGiftWrapVid = document.querySelector('.drawer__items') ? document.querySelector('.drawer__items').getAttribute('data-line-ribbon-gift-wrap-vid') : null

    if(lineRibbonGiftWrapVid) {
      const giftWrapVidNum = parseInt(lineRibbonGiftWrapVid, 10)
      const { items } = cart

      items.forEach((wrapItem) => {
        if(wrapItem.id !== giftWrapVidNum) return
        const forLineKey = wrapItem.properties && wrapItem.properties['_gift_wrap_for_line']
        if(!forLineKey) return

        const sourceItem = items.find((i) => i.key === forLineKey)

        if(!sourceItem) {
          // Source line was removed entirely - remove the now-orphaned gift wrap line
          updates[wrapItem.key] = 0
        } else if(sourceItem.quantity !== wrapItem.quantity) {
          // Source line's quantity changed (incremented/decremented) - match it
          updates[wrapItem.key] = sourceItem.quantity
        }
      })
    }

    if(Object.keys(updates).length > 0) {
      updateCart({
        url: '/cart/update.js',
        data: JSON.stringify({
          updates,
          sections: "cart-drawer,cart-icon-bubble,main-cart-items,header"
        })
      })
      return
    }

    // remove all product card spinner
    document.querySelectorAll('.card-wrapper .loading-overlay__spinner.active').forEach(spinner => {
      spinner.classList.remove('active')
    });

    document.dispatchEvent(
      new CustomEvent('cart:updated', {
        detail: {
          cart,
        },
      })
    );
  };

  if(latestCartItems) {
    finishCartUpdate({ ...json, items: latestCartItems });
  } else {
    // Fallback - should be rare (only if the "header" section wasn't part of this response). A
    // single cart.js request is unavoidable here since there's no other source of truth available.
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(response => response.json())
      .then(data => finishCartUpdate(data));
  }

  // Get the currUpdatedItemID from window and add scrollIntoView()
  let selector = `.drawer__items [data-variant-id="${window.currUpdatedItemID}"]`;
  let lastUpdatedItemID = document.querySelector(selector);
  if(lastUpdatedItemID){
    setTimeout(function(){
      lastUpdatedItemID.scrollIntoView(false);
    }, 100);
  }

  if(document.querySelector(`[data-empty-div]`) != null) {
    document.querySelector(`[data-empty-div]`).classList.add('hidden');
  }
  
  document.querySelectorAll('.loading-overlay').forEach(loader => {
    loader.classList.add('hidden');
  });
  
  const productAddButton = document.querySelector('.product-form__submit');
  if(productAddButton) {
    productAddButton.classList.remove('loading');
    productAddButton.removeAttribute('aria-disabled');
    productAddButton.querySelector('.loading-overlay__spinner').classList.add('hidden');
  }
  
  const cartOpen = document.getElementById('Details-cart-drawer-container').hasAttribute('open');
  const onCartPage = window.location.href.indexOf('/cart') > -1;
  if(!cartOpen && !onCartPage) {
    document.querySelector('#Details-cart-drawer-container .header__icon--menu').click();
  }

  window.buildCompleteTheSetInCart()

  if(!onCartPage) {
    const itemRemovedCartDrawer = new Event("itemRemovedFromCartDrawer");
    document.dispatchEvent(itemRemovedCartDrawer);
  }

  if (onCartPage && document.querySelector(".cart-items.cart-page-items").getAttribute("data-qty-updated") === "true") {
    window.location.href = '/cart';
  }
}

// GWP Auto-Add/Remove Management
let isManagingGWP = false; // Prevent infinite loops

document.addEventListener('cart:updated', function(event) {

  // Prevent infinite loops
  if (isManagingGWP) {
    return;
  }
  
  const cart = event.detail.cart;
  const progressBarContainer = document.querySelector('.progress-bar-container');
  
  if (!progressBarContainer) return;
  
  const gwpTiersData = progressBarContainer.getAttribute('data-gwp-tiers');
  if (!gwpTiersData) return;
  
  let gwpTiers = [];
  try {
    gwpTiers = JSON.parse(gwpTiersData);
  } catch (e) {
    console.error('Failed to parse GWP tiers data:', e);
    return;
  }
  
  if (gwpTiers.length === 0) return;
  
  const cartItems = cart.items;
  
  // Calculate cart total EXCLUDING any GWP products to prevent circular logic
  // where the GWP itself pushes the cart over the threshold
  const gwpVariantIds = gwpTiers.map(tier => tier.variantId);
  const gwpTotalInCart = cartItems
    .filter(item => gwpVariantIds.includes(item.variant_id))
    .reduce((total, item) => total + item.final_line_price, 0);
  
  const cartTotal = (cart.total_price - gwpTotalInCart) / 100; // Convert cents to dollars, excluding GWP value
  
  // Determine which GWP products should be in cart based on thresholds met
  const gwpsToManage = gwpTiers.map(tier => {
    const thresholdMet = cartTotal >= tier.threshold;
    const isInCart = cartItems.some(item => item.variant_id === tier.variantId);
    const isFreeGWP = tier.productPrice === 0;
    
    return {
      variantId: tier.variantId,
      threshold: tier.threshold,
      thresholdMet: thresholdMet,
      isInCart: isInCart,
      isFreeGWP: isFreeGWP,
      shouldAdd: thresholdMet && !isInCart,
      shouldRemove: !thresholdMet && isInCart && isFreeGWP // Only remove free GWPs
    };
  });
  
  // Check if any actions are needed
  const itemsToAdd = gwpsToManage.filter(gwp => gwp.shouldAdd);
  const itemsToRemove = gwpsToManage.filter(gwp => gwp.shouldRemove);
  
  if (itemsToAdd.length === 0 && itemsToRemove.length === 0) return;
  
  // Set flag to prevent infinite loops
  isManagingGWP = true;
  
  // Process GWP updates
  (async () => {
    try {
      // If threshold is NOT met, remove free GWP items (price = 0)
      if (itemsToRemove.length > 0) {
        const updates = {};
        itemsToRemove.forEach(gwp => {
          updates[gwp.variantId] = 0;
        });
        
        const removeResponse = await fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify({ updates })
        });
        
        if (!removeResponse.ok) {
          throw new Error('Failed to remove GWP items');
        }
      }
      
      // If threshold IS met and item NOT in cart, add it
      if (itemsToAdd.length > 0) {
        const items = itemsToAdd.map(gwp => ({
          id: gwp.variantId,
          quantity: 1,
          properties: {
            '_free_gift': 'true'
          }
        }));
        
        const addResponse = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify({ items })
        });
        
        if (!addResponse.ok) {
          throw new Error('Failed to add GWP items');
        }
      }
      
      // Fetch updated cart with sections
      const sectionsResponse = await fetch(
        window.Shopify.routes.root + 'cart?sections=cart-drawer,cart-icon-bubble,main-cart-items,header',
        {
          headers: {
            'X-Requested-With': 'xmlhttprequest'
          }
        }
      );
      
      const sectionsData = await sectionsResponse.json();
      
      // Wrap sections data in the expected format for cartUpdate
      const data = { sections: sectionsData };
      cartUpdate(data);
      
    } catch (error) {
      console.error('GWP update error:', error);
    } finally {
      // Reset flag after a delay to allow cart to update
      setTimeout(() => {
        isManagingGWP = false;
      }, 1000);
    }
  })();
});

const headerScroll = (h) => {
 
  let headerWrapper = document.querySelector('.header-wrapper');
  let mainContent = document.getElementById('MainContent');
  var scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
  if (scrollTop >= mainContent.offsetTop) {
    headerWrapper.classList.add("header--scrolled");
  } 
  else {
    headerWrapper.classList.remove("header--scrolled");
  }

};


window.onscroll = function() {
  // headerScroll();
};


const footerCollapse = () => {
  const footerButtons = document.querySelectorAll('.footer-block__link_list .button--inline');
  footerButtons.forEach(footerButton => {
    footerButton.addEventListener('click',event => {
      event.preventDefault();
      const isOpen = footerButton.getAttribute('aria-expanded') == 'true';
      const controlledEl = document.getElementById(footerButton.getAttribute('aria-controls'));
      if(isOpen) {
        controlledEl.style.display = 'none';
      } else {
        controlledEl.style.display = 'block';
      }
      footerButton.setAttribute('aria-expanded',!isOpen);
    });
  });
};

footerCollapse();


const initNewMobileNavArea = () => {
  document.querySelectorAll('.new-mobile-nav-area__container').forEach((container) => {
    const headerLinks = container.querySelectorAll('[data-nav-header]');
    const panels = container.querySelectorAll('[data-nav-panel]');

    headerLinks.forEach((headerLink) => {
      headerLink.addEventListener('click', () => {
        const key = headerLink.getAttribute('data-nav-key');
        const wasActive = headerLink.classList.contains('is-active');

        headerLinks.forEach((link) => {
          link.classList.remove('is-active');
          link.setAttribute('aria-expanded', 'false');
        });
        panels.forEach((panel) => {
          panel.classList.remove('is-active');
        });

        if (!wasActive) {
          headerLink.classList.add('is-active');
          headerLink.setAttribute('aria-expanded', 'true');

          panels.forEach((panel) => {
            if (panel.getAttribute('data-nav-key') === key) {
              panel.classList.add('is-active');
            }
          });
        }
      });
    });
  });
};

initNewMobileNavArea();


const initMobileMenuDrawerUnderlay = () => {
  const mobileMenuDrawerDetails = document.getElementById('Details-menu-drawer-container');
  if (!mobileMenuDrawerDetails) return;

  const underlay = mobileMenuDrawerDetails.querySelector('.mobile-menu-drawer-underlay');
  const summary = mobileMenuDrawerDetails.querySelector('summary');
  if (!underlay || !summary) return;

  underlay.addEventListener('click', () => {
    if (mobileMenuDrawerDetails.hasAttribute('open')) summary.click();
  });
};

initMobileMenuDrawerUnderlay();


document.addEventListener('shopify:section:load', event => {
  lazyImages();
  playPauseVideo();
  productCardHovers();
  klaviyoForms();
  headerScroll();
  footerCollapse();
  initNewMobileNavArea();
  initMobileMenuDrawerUnderlay();
});



if(window.transparentHeader) {
  window.onload = (event) => {
    let mainContent = document.getElementById('MainContent');
    let headerWrapper = document.querySelector('.header-wrapper');
    if (mainContent && headerWrapper) {
      mainContent.style.marginTop = `-${headerWrapper.offsetHeight}px`;
    }
  };

}

// Wait for full page load to ensure header has reached final size
window.addEventListener('load', () => {
  if(window.announcementSticky) {
    let announcementContent = document.getElementById('shopify-section-announcement-bar');
    if(announcementContent) {
      document.querySelector('#shopify-section-header').style.setProperty('--announcement-sticky', `${announcementContent.offsetHeight}px`);
    }
  }
  
  // Recalculate after 3 seconds to account for any delayed asset loading
  setTimeout(() => {
    if(window.announcementSticky) {
      let announcementContent = document.getElementById('shopify-section-announcement-bar');
      if(announcementContent) {
        document.querySelector('#shopify-section-header').style.setProperty('--announcement-sticky', `${announcementContent.offsetHeight}px`);
      }
    }
  }, 1000);
});

window.addEventListener("resize", () => {
  if(window.announcementSticky) {
    let announcementContent = document.getElementById('shopify-section-announcement-bar');
    if(announcementContent) {
      document.querySelector('#shopify-section-header').style.setProperty('--announcement-sticky', `${announcementContent.offsetHeight}px`);
    }
  }
});

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (this.classList.contains('complimentary-products')) {
            // console.log('complientary')
            // this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
          lazyImages();
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

// @desc Check GWP is in Cart
// @params variantId
// @return true/false
const isProductInCart = async (variantId) => {
  try {
    const response = await fetch('/cart.json', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const data = await response.json();
    const cartItems = data.items;

    return cartItems.some(item => item.id === variantId);
  } catch (error) {
    console.error('There has been a problem with your fetch operation:', error);
    return false;
  }
}

// @desc Add a standalone product or a product with GWP
// @params productId, variantId?
const addToCartPromo = async (productId, addOnId = null) => {
  let itemsObj = {
    items: [
      {
        id: productId,
        quantity: 1,
        properties: {
          "_IDPromotion": "IDPromotion"
        }
      }
    ]
  };

  if (addOnId) {
    itemsObj.items.push({
      id: addOnId,
      quantity: 1,
      properties: {
        "_IDPromotion": "AddOnPromotion"
      }
    });
  }

  addToCart(itemsObj);
}

jsLoad = true;


// function getOS() {
//   let userAgent = navigator.userAgent.toLowerCase();

//   if (userAgent.includes("win")) {
//     document.body.classList.add('os-windows');
//   } else if (userAgent.includes("mac")) {
//     document.body.classList.add('os-macOs');
//   } else if (userAgent.includes("linux")) {
//     document.body.classList.add('os-linux');
//   } else if (userAgent.includes("android")) {
//     document.body.classList.add('os-android');
//   } else if (userAgent.includes("iphone") || userAgent.includes("ipad")) {
//     document.body.classList.add('os-iphone');
//   }
  
//   if (userAgent.includes("safari") && !userAgent.includes("chrome")) {
//     document.body.classList.add('browser-safari');
//   }

// }

// getOS();

const findElement = setInterval(expressCheckout, 1000);

function expressCheckout() {
  if(document.querySelector('shopify-paypal-button')) {
    document.querySelector('shopify-paypal-button').remove();
    if(document.querySelector('shopify-google-pay-button')) {
      document.querySelector('shopify-google-pay-button').remove();
    }
    if(document.querySelector('shopify-apple-pay-button')) {
      document.querySelector('shopify-apple-pay-button').remove();
    }
    stopFindElement();
  }
}

function stopFindElement() {
  clearInterval(findElement);
}


class GiftingTooltipContainer extends HTMLElement {
    constructor() {
      super()
    }
}

customElements.define('gifting-tooltip-container', GiftingTooltipContainer)

class HideShowSilhouetteCarouselButton extends HTMLElement {
    constructor() {
        super();
        this.btn = this.querySelector('.silhouette-carousel__hide-btn');
        this.sectionId = this.dataset.sectionId;
    }

    connectedCallback() {
        this.section = document.querySelector(`[data-section-id="${this.sectionId}"]`);
        this.setAttribute('data-hidden', 'false');
        this.btn?.addEventListener('click', () => this.toggle());
        this.querySelector('span')?.addEventListener('click', () => this.toggle());
    }

    toggle() {
        const hidden = this.section.classList.toggle('silhouette-carousel--hidden');
        this.btn.textContent = hidden ? 'View All' : 'Hide';
        this.setAttribute('data-hidden', hidden ? 'true' : 'false');
    }
}

customElements.define('hide-show-silhouette-carousel-button', HideShowSilhouetteCarouselButton);

class PullNotchButton extends HTMLElement {
  _getOffset() {
    const announcementBar = document.getElementById('shopify-section-announcement-bar')
    const header = document.getElementById('shopify-section-header')
    return (announcementBar ? announcementBar.offsetHeight : 0) + (header ? header.offsetHeight : 0)
  }

  _lockScroll() {
    this._isTransitioning = true
    this._scrollLockHandler = (e) => e.preventDefault()
    document.addEventListener('touchmove', this._scrollLockHandler, { passive: false })
    clearTimeout(this._transitionTimer)
    this._transitionTimer = setTimeout(() => {
      this._isTransitioning = false
      if (this._scrollLockHandler) {
        document.removeEventListener('touchmove', this._scrollLockHandler)
        this._scrollLockHandler = null
      }
    }, 700)
  }

  scrollToInfo() {
    if (this._isTransitioning) return
    this._inInfoState = true
    const top = this.getBoundingClientRect().top + window.scrollY - this._getOffset()
    window.scrollTo({ top, behavior: 'smooth' })
    this._lockScroll()
  }

  scrollToCarousel() {
    if (this._isTransitioning) return
    this._inInfoState = false
    const carousel = document.getElementById('product__mobile-images')
    if (!carousel) return
    const top = carousel.getBoundingClientRect().top + window.scrollY - this._getOffset()
    window.scrollTo({ top, behavior: 'smooth' })
    this._lockScroll()
  }

  connectedCallback() {
    this._isTransitioning = false
    this._inInfoState = false
    this._scrollLockHandler = null

    // Click toggles between states
    this._onClick = () => {
      if (this._inInfoState) this.scrollToCarousel()
      else this.scrollToInfo()
    }

    // Touch on notch: directional swipe
    this._touchStartY = 0
    this._onTouchStart = (e) => {
      this._touchStartY = e.touches[0].clientY
    }
    this._onTouchEnd = (e) => {
      const deltaY = this._touchStartY - e.changedTouches[0].clientY
      if (deltaY > 20) this.scrollToInfo()
      else if (deltaY < -20) this.scrollToCarousel()
    }

    // Page scroll: when in info state, detect if user scrolled notch back down
    this._onPageScroll = () => {
      if (!this._inInfoState || this._isTransitioning) return
      const rect = this.getBoundingClientRect()
      const offset = this._getOffset()
      if (rect.top > offset + 5) {
        this.scrollToCarousel()
      }
    }

    // Document-level touch: detect upward swipe anywhere on the page
    this._docTouchStartY = 0
    this._docTouchStartScrollY = 0
    this._docTouchStartTarget = null
    this._onDocTouchStart = (e) => {
      this._docTouchStartY = e.touches[0].clientY
      this._docTouchStartScrollY = window.scrollY
      this._docTouchStartTarget = e.target
    }
    this._onDocTouchEnd = (e) => {
      if (this._inInfoState || this._isTransitioning) return
      // If touch started inside the carousel, let its own overscroll handler manage it
      const carousel = document.getElementById('product__mobile-images')
      if (carousel && carousel.contains(this._docTouchStartTarget)) return
      const deltaFinger = this._docTouchStartY - e.changedTouches[0].clientY
      const deltaScroll = window.scrollY - this._docTouchStartScrollY
      // Snap to info if finger swiped up ≥50px, or page scrolled up ≥30px
      if (deltaFinger > 50 || deltaScroll > 30) {
        this.scrollToInfo()
      }
    }

    this.addEventListener('click', this._onClick)
    this.addEventListener('touchstart', this._onTouchStart, { passive: true })
    this.addEventListener('touchend', this._onTouchEnd, { passive: true })
    window.addEventListener('scroll', this._onPageScroll, { passive: true })
    document.addEventListener('touchstart', this._onDocTouchStart, { passive: true })
    document.addEventListener('touchend', this._onDocTouchEnd, { passive: true })
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick)
    this.removeEventListener('touchstart', this._onTouchStart)
    this.removeEventListener('touchend', this._onTouchEnd)
    window.removeEventListener('scroll', this._onPageScroll)
    document.removeEventListener('touchstart', this._onDocTouchStart)
    document.removeEventListener('touchend', this._onDocTouchEnd)
    clearTimeout(this._transitionTimer)
    if (this._scrollLockHandler) {
      document.removeEventListener('touchmove', this._scrollLockHandler)
    }
  }
}

customElements.define('pull-notch-button', PullNotchButton);

class PdpSaveForLaterButton extends HTMLElement {
  _isSavedByProduct() {
    const productId = String(this.getAttribute('data-product-id'))
    const savedItems = JSON.parse(localStorage.getItem('saveForLater') || '{}')
    return Object.values(savedItems).some(item => String(item.product_level_id) === productId)
  }

  _updateState() {
    const textEl = this.querySelector('.pdp-sfl-text')
    if (!textEl) return
    if (this._isSavedByProduct()) {
      this.classList.add('saved')
      textEl.textContent = 'Saved for later'
    } else {
      this.classList.remove('saved')
      textEl.textContent = 'Save for later'
    }
  }

  _openCartWithSFL() {
    const details = document.getElementById('Details-cart-drawer-container')
    if (details && !details.hasAttribute('open')) {
      const summary = details.querySelector('summary')
      if (summary) summary.click()
    }
    setTimeout(() => {
      const sfl = document.querySelector('saved-for-later-container')
      if (sfl && !sfl.isOpen) {
        const toggle = sfl.querySelector('.saved-for-later__toggle')
        if (toggle) toggle.click()
      }
      // After the SFL section finishes expanding, scroll it to the center of the cart
      setTimeout(() => {
        const sfl = document.querySelector('saved-for-later-container')
        if (sfl) sfl.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }, 450)
    }, 350)
  }

  connectedCallback() {
    if (!this.querySelector('.pdp-sfl-text')) {
      this.innerHTML = '<span class="pdp-sfl-text">Save for later</span><span class="pdp-sfl-spinner" aria-hidden="true"><svg focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></span>'
    }

    this._updateState()
    this._onSFLUpdated = () => this._updateState()
    document.addEventListener('saveForLater:updated', this._onSFLUpdated)

    this._onClick = () => {
      if (this.classList.contains('is-saving') || this.classList.contains('saved')) return

      this.style.width = `${this.getBoundingClientRect().width}px`
      this.classList.add('is-saving')

      setTimeout(() => {
        const productId = this.getAttribute('data-product-id')
        const variantId = this.getAttribute('data-variant-id')
        const variantUrl = this.getAttribute('data-variant-url')
        const variantImage = this.getAttribute('data-variant-image')
        const variantTitle = this.getAttribute('data-variant-title')
        const variantPrice = this.getAttribute('data-variant-price')
        const variantColor = this.getAttribute('data-variant-color')

        const savedItems = JSON.parse(localStorage.getItem('saveForLater') || '{}')
        savedItems[variantId] = {
          product_level_id: productId,
          variant_add_to_cart_id: variantId,
          variant_url: variantUrl,
          variant_image_string: variantImage,
          variant_formatted_title: variantTitle,
          variant_string_price: variantPrice,
          variant_color: variantColor && variantColor !== '' ? variantColor : null
        }
        localStorage.setItem('saveForLater', JSON.stringify(savedItems))

        document.dispatchEvent(new CustomEvent('saveForLater:updated', {
          detail: { action: 'added', variantId, savedItems }
        }))

        this.classList.remove('is-saving')
        this.classList.add('saved')
        this.style.width = ''
        const textEl = this.querySelector('.pdp-sfl-text')
        if (textEl) textEl.textContent = 'Saved for later'

        fetch(window.Shopify.routes.root + 'cart?sections=cart-drawer,cart-icon-bubble,main-cart-items,header', {
          headers: { 'X-Requested-With': 'xmlhttprequest' }
        })
          .then(r => r.json())
          .then(sections => {
            cartUpdate({ sections })
            this._openCartWithSFL()
          })
          .catch(() => this._openCartWithSFL())
      }, 500)
    }
    this.addEventListener('click', this._onClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick)
    document.removeEventListener('saveForLater:updated', this._onSFLUpdated)
  }
}

customElements.define('pdp-save-for-later-button', PdpSaveForLaterButton);

class ReadMoreDescription extends HTMLElement {
  connectedCallback() {
    const btn = this.querySelector('.read-more-desc__btn');
    if (!btn) return;

    btn.addEventListener('click', () => {
      const desc = this.querySelector('.product_description');
      const overlay = this.querySelector('.read-more-desc__overlay');
      if (desc) { desc.style.maxHeight = 'none'; desc.style.overflow = 'visible'; }
      if (overlay) overlay.classList.add('expanded');
    });
  }
}
customElements.define('read-more-description', ReadMoreDescription);

class PdpExploreMoreColorways extends HTMLElement {
  static expandedBodyClass = 'pdp-colorway-options-expanded';

  connectedCallback() {
    this.colorwayContainer = this.closest('.colorway-optimized');
    if (!this.colorwayContainer) return;

    this.groupWrappers = Array.from(
      this.colorwayContainer.querySelectorAll('.variant-picker-group-wrapper')
    );
    this.availableGroups = this.groupWrappers.filter((groupWrapper) => groupWrapper.querySelector('li'));

    if (this.availableGroups.length <= 1) {
      this.hidden = true;
      return;
    }

    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');
    this.setAttribute('aria-expanded', 'false');

    const shouldStayExpanded = this.shouldStartExpanded();
    if (shouldStayExpanded) {
      this.expandOptions();
    }

    this.onExpand = () => {
      this.expandOptions();
    };

    this.onKeydown = (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this.onExpand();
    };

    this.addEventListener('click', this.onExpand);
    this.addEventListener('keydown', this.onKeydown);
  }

  disconnectedCallback() {
    if (this.onExpand) {
      this.removeEventListener('click', this.onExpand);
    }

    if (this.onKeydown) {
      this.removeEventListener('keydown', this.onKeydown);
    }
  }

  shouldStartExpanded() {
    return document.body.classList.contains(PdpExploreMoreColorways.expandedBodyClass);
  }

  expandOptions() {
    if (!this.colorwayContainer.classList.contains('colorway-expanded')) {
      this.colorwayContainer.classList.add('colorway-expanded');
    }

    this.setAttribute('aria-expanded', 'true');
    document.body.classList.add(PdpExploreMoreColorways.expandedBodyClass);
  }
}

customElements.define('pdp-explore-more-colorways', PdpExploreMoreColorways);

// Trigger for the "explore more colorways" drawer variant (used instead of
// `pdp-explore-more-colorways` when the `enable_variant_drawer` section setting is on).
// Mirrors `PdpExploreMoreColorways`'s "hide if there's nothing to explore" logic: if there's
// only one (or zero) colorway "type" (size/strap category) available, don't offer the drawer.
class PdpExploreMoreColorwaysDrawerTrigger extends HTMLElement {
  connectedCallback() {
    this.colorwayContainer = this.closest('.colorway-optimized');
    if (!this.colorwayContainer) return;

    const groupWrappers = Array.from(this.colorwayContainer.querySelectorAll('.variant-picker-group-wrapper'));
    const availableGroups = groupWrappers.filter((groupWrapper) => groupWrapper.querySelector('li'));

    if (availableGroups.length <= 1) {
      this.hidden = true;
      return;
    }

    this.setAttribute('role', 'button');
    this.setAttribute('tabindex', '0');

    this._onOpen = () => {
      // The drawer portals itself to <body> (see `PdpColorwayDrawer`), so it's no longer a
      // descendant of `.colorway-optimized` - look it up globally instead.
      const drawer = document.querySelector('pdp-colorway-drawer');
      if (drawer && typeof drawer.open === 'function') drawer.open();
    };

    this._onKeydown = (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      this._onOpen();
    };

    this.addEventListener('click', this._onOpen);
    this.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    if (this._onOpen) this.removeEventListener('click', this._onOpen);
    if (this._onKeydown) this.removeEventListener('keydown', this._onKeydown);
  }
}

customElements.define('pdp-explore-more-colorways-drawer-trigger', PdpExploreMoreColorwaysDrawerTrigger);

// The drawer opened by `pdp-explore-more-colorways-drawer-trigger`. Acts as a variant
// picker: Row 1 is the product title + close button, Row 2 is a set of category tabs (one
// per available colorway group), Row 3 is a swatch grid for the active category. Rows 2 & 3
// are rendered entirely server-side by the Liquid snippet (same product-filtering loops that
// build the main picker also build these, capturing a parallel copy of each qualifying `<li>`
// as they go) - this element just wires up interaction (open/close/tab-switching) on top of
// markup that's already fully formed by the time it reaches the browser.
class PdpColorwayDrawer extends HTMLElement {
  static openBodyClass = 'pdp-colorway-drawer-open';

  connectedCallback() {
    // Move this element to <body>. It uses `position: fixed`, which was being clipped/
    // mis-positioned under the header because a transformed/positioned PDP ancestor
    // (carousels/sliders elsewhere on the page use CSS transforms) becomes the fixed-position
    // containing block instead of the viewport. Portaling avoids that entirely. Because the
    // whole snippet (including this element's already-populated markup) is re-rendered fresh
    // by the server on every variant swap, the stale copy left behind in <body> is removed
    // here in favor of the freshly-arrived one, which then portals itself the same way.
    if (this.parentElement !== document.body) {
      document.querySelectorAll('pdp-colorway-drawer').forEach((el) => {
        if (el !== this) el.remove();
      });
      document.body.appendChild(this);
      return; // appendChild re-triggers disconnectedCallback + connectedCallback on `this`
    }

    this.categoriesEl = this.querySelector('.pdp-colorway-drawer__categories');
    this.groupsEl = this.querySelector('.pdp-colorway-drawer__swatch-groups');
    this.underlay = this.querySelector('.pdp-colorway-drawer__underlay');
    this.closeBtn = this.querySelector('.pdp-colorway-drawer__close');

    this.setAttribute('aria-hidden', 'true');

    // The swatch anchors below need the same click-to-swap behavior as the regular
    // customSwatch buttons. `productSwatchReload` skips already-bound elements, so it's safe
    // to call again here without double-binding the ones in the main picker.
    if (typeof productSwatchReload === 'function') productSwatchReload();

    this._onUnderlayClick = () => this.close();
    this._onCloseClick = () => this.close();
    this._onKeydown = (event) => {
      if (event.key === 'Escape') this.close();
    };
    this._onCategoryClick = (event) => {
      const btn = event.target.closest('.pdp-colorway-drawer__category-btn');
      if (!btn) return;
      this._setActiveGroup(btn.dataset.drawerGroup);
    };

    if (this.underlay) this.underlay.addEventListener('click', this._onUnderlayClick);
    if (this.closeBtn) this.closeBtn.addEventListener('click', this._onCloseClick);
    if (this.categoriesEl) this.categoriesEl.addEventListener('click', this._onCategoryClick);
    document.addEventListener('keydown', this._onKeydown);
  }

  disconnectedCallback() {
    if (this.underlay) this.underlay.removeEventListener('click', this._onUnderlayClick);
    if (this.closeBtn) this.closeBtn.removeEventListener('click', this._onCloseClick);
    if (this.categoriesEl) this.categoriesEl.removeEventListener('click', this._onCategoryClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  _setActiveGroup(groupKey) {
    this.categoriesEl.querySelectorAll('.pdp-colorway-drawer__category-btn').forEach((btn) => {
      btn.classList.toggle('active', btn.dataset.drawerGroup === groupKey);
    });
    this.groupsEl.querySelectorAll('.pdp-colorway-drawer__swatch-list').forEach((list) => {
      list.classList.toggle('active', list.dataset.drawerGroup === groupKey);
    });
  }

  open() {
    this.classList.add('is-open');
    this.setAttribute('aria-hidden', 'false');
    document.body.classList.add(PdpColorwayDrawer.openBodyClass);
  }

  close() {
    this.classList.remove('is-open');
    this.setAttribute('aria-hidden', 'true');
    document.body.classList.remove(PdpColorwayDrawer.openBodyClass);
  }

  showLoading() {
    this.classList.add('is-loading');
  }

  hideLoading() {
    this.classList.remove('is-loading');
  }
}

customElements.define('pdp-colorway-drawer', PdpColorwayDrawer);

// Relocated "Drop a hint" triggers (mobile carousel + desktop gallery). The real button
// the Drop-Hint app binds to lives in the product form (`.main-drop-a-hint-button`,
// id="cta_dropahint"). Having multiple elements share that id caused conflicts with the
// consentmo app, so these triggers just forward a click to the real button instead.
class HammittDropAHintTrigger extends HTMLElement {
  connectedCallback() {
    this._onClick = () => {
      const mainButton = document.querySelector('.main-drop-a-hint-button')
      if (mainButton) mainButton.click()
    }
    this.addEventListener('click', this._onClick)
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._onClick)
  }
}

customElements.define('hammitt-drop-a-hint-trigger', HammittDropAHintTrigger);

// Per-line-item gift ribbon upsell, rendered inside each eligible cart line's gifting
// accordion. Checking the box adds (or reuses) a distinct gift-wrap product cart line tagged
// with a "_gift_wrap_for_line" property set to the SOURCE line's key - the source line itself
// is never mutated, so its key stays stable. Unchecking looks up that associated gift-wrap
// line (via the current cart data, no extra request) and removes it. Quantity changes/removals
// of the source line are reconciled separately, centrally, inside cartUpdate() in this file.
class CartLevelLineRibbonUpsell extends HTMLElement {
  connectedCallback() {
    this.checkbox = this.querySelector('input[type="checkbox"]')
    if(!this.checkbox) return

    this.lineKey = this.dataset.lineKey
    this.giftWrapVid = parseInt(this.dataset.giftWrapVid, 10)
    this.isProcessing = false

    this.onChange = this.onChange.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    this.checkbox.addEventListener('change', this.onChange)
    this.checkbox.addEventListener('keydown', this.onKeydown)
  }

  disconnectedCallback() {
    if(this.checkbox) {
      this.checkbox.removeEventListener('change', this.onChange)
      this.checkbox.removeEventListener('keydown', this.onKeydown)
    }
  }

  // Native checkboxes only toggle on Space; add Enter support for keyboard users.
  onKeydown(event) {
    if(event.key === 'Enter') {
      event.preventDefault()
      this.checkbox.checked = !this.checkbox.checked
      this.checkbox.dispatchEvent(new Event('change', { bubbles: true }))
    }
  }

  getSourceLineQuantity() {
    const lineEl = document.querySelector(`[data-key="${this.lineKey}"]`)
    let quantity = parseInt(this.dataset.lineQuantity, 10)

    if(lineEl) {
      const domQty = parseInt(lineEl.dataset.qty, 10)
      if(!isNaN(domQty)) quantity = domQty
    }

    if(isNaN(quantity) || quantity < 1) quantity = 1

    return quantity
  }

  // Finds the gift-wrap product line already associated with this source line, reading the
  // current cart state straight out of the DOM (.drawer__items data-json), avoiding any
  // extra network request.
  findAssociatedGiftWrapLine() {
    const drawerItemsEl = document.querySelector('.drawer__items')
    if(!drawerItemsEl) return null

    const rawJson = drawerItemsEl.getAttribute('data-json')
    if(!rawJson) return null

    try {
      const items = JSON.parse(rawJson)
      return items.find((item) => (
        item.id === this.giftWrapVid &&
        item.properties &&
        item.properties['_gift_wrap_for_line'] === this.lineKey
      )) || null
    } catch(e) {
      return null
    }
  }

  showLoading() {
    const loadingOverlay = document.querySelector('cart-items .loading-overlay')
    if(loadingOverlay) loadingOverlay.classList.remove('hidden')

    const cartItemsEl = document.querySelector('cart-items')
    if(cartItemsEl) cartItemsEl.classList.add('cart__items--disabled')
  }

  hideLoading() {
    const loadingOverlay = document.querySelector('cart-items .loading-overlay')
    if(loadingOverlay) loadingOverlay.classList.add('hidden')

    const cartItemsEl = document.querySelector('cart-items')
    if(cartItemsEl) cartItemsEl.classList.remove('cart__items--disabled')
  }

  async onChange(event) {
    if(this.isProcessing) {
      event.preventDefault()
      event.target.checked = !event.target.checked
      return
    }

    this.isProcessing = true
    this.showLoading()

    try {
      await this.setGiftWrapSelected(event.target.checked)
    } finally {
      this.isProcessing = false
      this.hideLoading()
    }
  }

  async setGiftWrapSelected(selected) {
    const quantity = this.getSourceLineQuantity()
    const existingGiftWrapLine = this.findAssociatedGiftWrapLine()

    // Nothing to do if the cart already matches the desired state (e.g. a stale re-click)
    if(selected && existingGiftWrapLine && existingGiftWrapLine.quantity === quantity) return
    if(!selected && !existingGiftWrapLine) return

    try {
      let response

      if(selected) {
        if(existingGiftWrapLine) {
          // Already exists (e.g. stale state) - set its quantity to match rather than adding more
          response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: existingGiftWrapLine.key,
              quantity,
              properties: { '_gift_wrap_for_line': this.lineKey },
              sections: 'cart-drawer,cart-icon-bubble,main-cart-items,header'
            })
          })
        } else {
          response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: [{
                id: this.giftWrapVid,
                quantity,
                properties: { '_gift_wrap_for_line': this.lineKey }
              }],
              sections: 'cart-drawer,cart-icon-bubble,main-cart-items,header'
            })
          })
        }
      } else {
        response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: existingGiftWrapLine.key,
            quantity: 0,
            sections: 'cart-drawer,cart-icon-bubble,main-cart-items,header'
          })
        })
      }

      if(response.ok) {
        const data = await response.json()
        if(typeof cartUpdate === 'function') await cartUpdate(data)
      }
    } catch(error) {
      console.error('Error updating gift ribbon selection for line item:', error)
      this.checkbox.checked = !selected
    }
  }
}

if(!customElements.get('cart-level-line-ribbon-upsell')) {
  customElements.define('cart-level-line-ribbon-upsell', CartLevelLineRibbonUpsell)
}

document.addEventListener('click', function(e) {
  if (e.target.closest('.afterpay-site-modal')) {
    e.preventDefault();
    const modal = document.querySelector('afterpay-modal');
    if (modal) modal.setAttribute('visible', 'visible');
  }
});